export default "__VITE_ASSET__jpzDja0l__"